import React, { PureComponent } from 'react';
import { Link } from 'react-router';
import { hashCode } from '../../utils/hashCode';
import getUrl from '@/routes/routes/helpers/getUrl';

import styles from './styles.module.css';
import CustomQuestionSubmit from './utils/CustomQuestionSubmit';

const getReactHtml = (html) => ({ __html: html });

const Faq = ({ question, answer, questionClass, answerClass }) => (
  <div className={styles.faq}>
    <div className={questionClass || styles.question}>{question}</div>
    <div
      className={answerClass || styles.answer}
      // eslint-disable-next-line react/no-danger
      dangerouslySetInnerHTML={getReactHtml(answer)}
    />
  </div>
);

class Faqs extends PureComponent {
  render() {
    const {
      eventId,
      titleClass,
      questionClass,
      answerClass,
      faqs,
      hideAskQuestion,
      trackingPrefix,
    } = this.props;

    const footer = (
      <p className={styles.label}>
        <span>Is your question about booking your place? </span>
        <Link
          className={styles.helpCenterLink}
          target="_blank"
          rel="noopener noreferrer nofollow"
          to={getUrl.helpCenter()}
        >
          See our Help Center
        </Link>
      </p>
    );

    return (
      <div>
        <h2 className={titleClass}>Frequently Asked Questions</h2>
        {faqs.map((faq) => (
          <Faq
            key={hashCode(faq.question)}
            {...faq}
            questionClass={questionClass}
            answerClass={answerClass}
          />
        ))}
        {!hideAskQuestion && (
          <CustomQuestionSubmit
            eventId={eventId}
            footer={footer}
            name="faq_question"
            placeholder="What would you like to know about this event?"
            title="Have a question? Get answers from our team."
            trackingPrefix={trackingPrefix}
          />
        )}
      </div>
    );
  }
}

export default Faqs;
